





























































































































import Vue from 'vue';
import TopNav from '@/web/components/navigation/TopNav.vue';
import NavItem from '@/web/components/navigation/NavItem.vue';
import CouponTitle from '@/web/components/coupons/CouponTitle.vue';
import { mapGetters, mapState } from 'vuex';
import moment from 'moment';
import { notify } from '@/web/utils/notify';
import { formatCurrency, formatDate } from '@/web/utils/format';

interface LocalState {
  fields: PaginatedTableField[];
  statusTypes: SelectType[];
  selectedStatusValue: boolean | null;
  search: string;
  formLoaded: boolean;
}

export default Vue.extend({
  name: 'Coupons',
  components: {
    TopNav,
    NavItem,
    CouponTitle,
  },
  data(): LocalState {
    return {
      search: '',
      formLoaded: false,
      selectedStatusValue: null,
      statusTypes: [
        {
          label: this.$t('PRODUCTS.LABELS.ALL_COUPONS') as string,
          code: null,
        },
        {
          label: this.$t('PRODUCTS.LABELS.ACTIVE_COUPONS') as string,
          code: 'true',
        },
        {
          label: this.$t('PRODUCTS.LABELS.INACTIVE_COUPONS') as string,
          code: 'false',
        },
      ],
      fields: [
        {
          title: this.$t('PRODUCTS.TABLE.COUPON_NAME') as string,
          name: 'name',
        },
        {
          title: this.$t('PRODUCTS.TABLE.COUPON_CODE') as string,
          key: 'code',
        },
        {
          title: this.$t('PRODUCTS.TABLE.DISCOUNT') as string,
          name: 'discount_amount',
        },
        {
          title: this.$t('PRODUCTS.TABLE.USED') as string,
          name: 'used',
        },
        {
          title: this.$t('PRODUCTS.TABLE.START') as string,
          name: 'redeem_start',
        },
        {
          title: this.$t('PRODUCTS.TABLE.EXPIRED') as string,
          name: 'redeem_end',
        },
        {
          name: 'edit',
          shrink: true,
          cssClass: 'p-0',
        },
        {
          name: 'actions',
          shrink: true,
          cssClass: 'p-0',
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      teacherCouponsStats: 'product/teacherCouponsStats',
    }),
    ...mapState('setting', ['paymentInfo']),
    selectedStatus: {
      get() {
        return this.selectedStatusValue;
      },
      set(value) {
        console.log('value=', value);
        this.selectedStatusValue = value;
      },
    },
    query(): {} {
      return {
        q: this.search,
        is_active: this.selectedStatus,
      };
    },
    teacherCouponsStatsTotalRevenue(): string {
      return formatCurrency(
        this.teacherCouponsStats.total_revenue,
        this.paymentInfo.currency
      );
    },
  },
  methods: {
    formatDate(date: string): string {
      return formatDate(date, 'date-word');
    },
    formatDiscount(data: TeacherCouponsResponse): string {
      const amount = data.discount_amount.toString();
      if (data.discount_type === 'percentage') {
        return `${amount}%`;
      }
      return formatCurrency(amount, this.paymentInfo.currency);
    },
    async deleteCoupon(id: number): Promise<void> {
      await this.$store.dispatch('product/deleteCoupon', id);
      notify(
        this.$t('PRODUCTS.MODAL.COUPON_DELETED').toString(),
        this.$t('PRODUCTS.MODAL.COUPON_DELETED_DESCRIPTION').toString()
      );
      this.$refs.couponTable.refresh();
    },
    openCouponDetail(id: number): void {
      this.$router.push(`/products/coupons/${id}/`);
    },
    editCoupon(id: number): void {
      this.$router.push(`/products/coupons/${id}/edit/`);
    },
    addCoupon(): void {
      this.$router.push('/products/coupons/create/');
    },
    getCouponStatus({ redeem_end, duration_type }): string {
      const isExpired = moment().isAfter(redeem_end);
      const isIncompatible =
        duration_type !== 'unlimited' &&
        this.paymentInfo?.payment_gateway === 'paypal';

      if (isExpired) return 'expired';
      else if (isIncompatible) return 'incompatible';
      else return 'active';
    },
  },
  async mounted() {
    const savedSearch = await this.$store.dispatch(
      'filters/getFilter',
      'coupons-table'
    );
    if (savedSearch) {
      this.search = savedSearch;
    }
    this.formLoaded = true;
    await this.$store.dispatch('setting/getPaymentInfo');
    this.$store.dispatch('product/getTeacherCouponsStats');
  },
  beforeDestroy() {
    this.$store.dispatch('filters/setFilter', {
      key: 'coupons-table',
      filter: this.search,
    });
  },
});
